export const TICKET_STATUS_CREATED = 'CREATED'
export const TICKET_STATUS_SOLD = 'SOLD'
export const TICKET_STATUS_VERIFIED = 'VERIFIED'
export const TICKET_STATUS_VOIDED = 'VOIDED'

export const OBJECT_TYPE_TICKET = 'TICKET'